<template>
  <a-table
    :columns="columns"
    :row-key="(record) => record.objId"
    :data-source="data"
    :pagination="pagination"
    :loading="loading"
    @change="handleTableChange"
  >
    <template slot="name" slot-scope="name">
      {{ name.first }} {{ name.last }}
    </template>
    <template slot="operate">
      <a v-on:click.prevent="showModal">编辑</a>
      <a-modal
        v-model="visible"
        title="编辑"
        @ok="handleOk"
        :maskStyle="{ opacity: 0.1 }"
        cancelText="取消"
        okText="确定"
      >
        <a-form-model
          :model="form"
          :label-col="labelCol"
          :wrapper-col="wrapperCol"
        >
          <a-form-model-item label="姓名">
            <a-input v-model="form.name" />
          </a-form-model-item>
          <a-form-model-item label="手机号码">
            <a-input v-model="form.name" />
          </a-form-model-item>
          <a-form-model-item label="邀请码">
            <a-input v-model="form.name" />
          </a-form-model-item>
          <a-form-model-item label="代理区域">
            <a-select
              v-model="form.region"
              placeholder="please select your zone"
            >
              <a-select-option value="shanghai"> Zone one </a-select-option>
              <a-select-option value="beijing"> Zone two </a-select-option>
            </a-select>
            <a-select
              v-model="form.region"
              placeholder="please select your zone"
            >
              <a-select-option value="shanghai"> Zone one </a-select-option>
              <a-select-option value="beijing"> Zone two </a-select-option>
            </a-select>
            <a-select
              v-model="form.region"
              placeholder="please select your zone"
            >
              <a-select-option value="shanghai"> Zone one </a-select-option>
              <a-select-option value="beijing"> Zone two </a-select-option>
            </a-select>
          </a-form-model-item>
        </a-form-model>
      </a-modal>
      <a
        href=""
        v-on:click.prevent="topage('/home/memberManagement/userPullsNew')"
        >通过</a
      >
      <a v-on:click.prevent="showModal2">不通过</a>
      <a-modal
        v-model="visible2"
        title="审核不通过"
        @ok="handleOk2"
        :maskStyle="{ opacity: 0.1 }"
        cancelText="取消"
        okText="确定"
      >
        <span>原因</span>
        <a-textarea
          v-model="value"
          placeholder="Controlled autosize"
          :auto-size="{ minRows: 3, maxRows: 5 }"
        />
      </a-modal>
    </template>
  </a-table>
</template>
<script>
import { userSignin } from "@/api/storeApi.js";
const columns = [
  {
    title: "编号",
    dataIndex: "objId",
    sorter: true,
  },
  {
    title: "用户uid",
    dataIndex: "userUid",
    align: "center",
  },
  {
    title: "手机号码",
    dataIndex: "phone",
    align: "center",
  },
  {
    title: "昵称",
    dataIndex: "nickName",
    sorter: true,
    align: "center",
    scopedSlots: { customRender: "" },
  },
  {
    title: "奖励(积分)",
    dataIndex: "countSignDay",
    sorter: true,
    align: "center",
  },
  {
    title: "签到日期",
    dataIndex: "signTime",
    sorter: true,
    align: "center",
    scopedSlots: { customRender: "" },
  },
];

export default {
  data() {
    return {
      data: [],
      loading: false,
      columns,
      visible: false,
      visible2: false,
      pagination: {
        current: 1,
        total: 0,
        showSizeChanger: true,
        pageSizeOptions: ["10", "20", "40", "80", "100"],
        showTotal: (total) => `共 ${total} 条`,
        pageSize: 10,
      },
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      form: {
        name: "",
        region: undefined,
      },
    };
  },
  mounted() {
    this.getUserSignin();
  },
  props: ["formInline"],
  methods: {
    topage(routerpath) {
      this.$router.push(routerpath);
    },
    getUserSignin() {
      userSignin({ limit: 10, page: 1 }).then((res) => {
        this.pagination.total = res.count;
        this.data = res.data;
      });
    },
    handleTableChange(pagination, filters, sorter) {
      console.log(pagination);
      this.loading = true;
      this.pagination.current = pagination.current; //重置当前页
      userSignin({ limit: 10, page: this.pagination.current }).then((res) => {
        this.data = res.data;
        console.log(res);
        this.loading = false;
      });
    },
    //
    onChange(checked) {
      console.log(`a-switch to ${checked}`);
    },
    //
    showModal() {
      this.visible = true;
    },
    handleOk(e) {
      console.log(e);
      this.visible = false;
    },
    showModal2() {
      this.visible2 = true;
    },
    handleOk2(e) {
      console.log(e);
      this.visible2 = false;
    },
    query() {
      this.loading = true;
      userSignin({
        limit: 10,
        page: 1,
        username: this.formInline.username,
        phone: this.formInline.phone,
        uid: this.formInline.uid,
      }).then((res) => {
        this.loading = false;
        this.data = res.data;
        this.pagination.total = res.count;
      });
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/views/systemManagement/userCheckinRecord/userCheckinRecordContent.vue